module.exports = __webpack_public_path__ + "media/images/flags/PS-392e8f42db4baab33612ce3dd3887d4c.svg";